module.exports = __webpack_public_path__ + "img/B3-4.e9bdc77d.jpg";